var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilvisionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 184.2 21.6",
    style: {
      enableBackground: "new 0 0 184.2 21.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#009FE3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svart_x2F_cyan",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "vit_x2F_cyan",
    className: "st0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svart_x2F_vit",
    className: "st0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.5,21.2h-9.1V0.4h8.6c4.1,0,6.8,2,6.8,5.1v0.1c0,2.8-1.8,4.3-3.5,4.9c2.5,0.7,4.7,2.1,4.7,5v0.1 C54,19,51,21.2,46.5,21.2z M51.2,5.6c0-2.3-1.9-3.8-5.2-3.8h-7V10h6.9C49,10,51.2,8.5,51.2,5.6L51.2,5.6z M52.4,15.5 c0-2.6-2.2-4.1-6.3-4.1H39v8.4h7.6C50.1,19.8,52.4,18.1,52.4,15.5L52.4,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,21.2V0.4H61v20.9H59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,21.2V0.4h1.6v19.4h12.2v1.4H67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91,21.4h-1.4l-9.2-21h1.7l8.2,19.2l8.2-19.2h1.6L91,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1,21.2V0.4h1.5v20.9H105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,21.5c-3.3,0-5.9-1.1-8.4-3.3l1-1.2c2.3,2.1,4.4,3.1,7.5,3.1c3.1,0,5.3-1.8,5.3-4.1v-0.1c0-2.2-1.2-3.5-5.9-4.4 c-5-1-7-2.7-7-5.9V5.5c0-3.1,2.8-5.5,6.7-5.5c3,0,5,0.8,7.2,2.5l-1,1.2c-2-1.7-3.9-2.4-6.2-2.4c-3.1,0-5.1,1.8-5.1,3.9v0.1 c0,2.2,1.1,3.5,6.1,4.6c4.8,1,6.9,2.7,6.9,5.8v0.1C127.4,19.2,124.5,21.5,120.4,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,21.2V0.4h1.5v20.9H133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,21.6c-6.3,0-10.5-5-10.5-10.7v-0.1c0-5.7,4.2-10.8,10.5-10.8c6.3,0,10.5,5,10.5,10.7c0,0,0,0,0,0.1 C161.3,16.5,157.1,21.6,150.8,21.6z M159.7,10.8c0-5.2-3.8-9.4-8.9-9.4c-5.2,0-8.9,4.2-8.9,9.3v0.1c0,5.2,3.8,9.4,8.9,9.4 C156,20.2,159.7,16,159.7,10.8L159.7,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,21.2L168.3,2.7v18.5h-1.5V0.4h1.5l14.4,18.1V0.4h1.5v20.9H183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,21.3C8.6,11.1,16.9,1.9,26.9,0.6l0,0c-0.7-0.1-1.4-0.1-2.1-0.1C13.3,0.4,1.3,11.6,0,21.3H8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3,21.3c0.3-4.2,0.7-16.2,9.8-20.5l0,0c-0.7,0.1-1.4,0.4-2.1,0.5c-11.6,3-15.8,14.2-15.7,20H17.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilvisionLogo);
export default __webpack_public_path__ + "static/media/bilvision-logo.d3128f2aee4f67c24558277cb207685a.svg";
export { ForwardRef as ReactComponent };